<template>
  <div class="d-flex justify-content-center align-items-center vh-100">
    <div class="row">
      <div class="col-md-6 d-flex justify-content-center align-items-center">
        <div class="container">
          <div class="d-none d-md-block d-lg-block d-xl-block">
            <img :src="image" alt="Image" class="mt-5 img-fluid" />
          </div>
          <h4 class="text-center">PAYZEEP AGENCY BANKING</h4>
        </div>
      </div>
      <div class="col-md-6 d-flex justify-content-center align-items-center">
        <div class="left-contents">
          <div class="d-flex justify-content-center align-items-center">
            <!-- <img
              src="../assets/img/"
              class="img-fluid"
            /> -->
          </div>
          <div class="d-flex justify-content-center align-items-center">
            <card class="card mt-5 border w-50" title="Login">
              <form @submit.prevent>
                <div class="row">
                  <div class="col-md-12 p-2">
                    <input
                      type="email"
                      class="form-control border"
                      label="Email"
                      placeholder="Email"
                      v-model="user.email"
                    />
                  </div>

                  <div class="col-md-12 p-2">
                    <input
                      type="password"
                      class="form-control border"
                      label="Password"
                      placeholder="Password"
                      v-model="user.password"
                    />
                  </div>
                </div>

                <div class="text-center">
                  <p-button
                    type="primary"
                    round
                    @click.native.prevent="loginUser"
                  >
                    <div
                      class="spinner-grow"
                      role="status"
                      v-if="loading.show === true"
                    ></div>
                    Login
                  </p-button>
                </div>
                <div class="clearfix"></div>
              </form>
            </card>
          </div>
          <div class="styled-box">
            <span class="icon"
              ><img
                src="@/assets/img/paymiSolution.png"
                alt="Powered by Paymi Solutions"
            /></span>
            <span class="styled-text"> Powered by Paymi Solutions </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      user: {
        email: "",
        password: "",
      },
      image: require("@/assets/img/banner-img-paymi.png"),
    };
  },
  computed: {
    ...mapState(["auth", "loading"]),
  },
  methods: {
    ...mapActions(["login"]),
    loginUser() {
      this.login(this.user);
    },
  },
};
</script>
<style>
.styled-box {
  margin-top: 4rem;
  margin-left: 8.5rem;
  margin-right: 8.5rem;
  display: flex;
  width: 192px;
  height: 40px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 4px;
  background: var(--Grey-White-Grey-100, #f7f7f7);
}
.icon {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: var(--Grey-White-White-full, #fff);
}
.styled-text {
  color: var(--Blue-Blue-primary, #2c3adf);
  font-family: "Work Sans";
  font-size: 10px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 200% */
  letter-spacing: -0.05px;
}
</style>
